import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';
import type { ScorePoint } from '../../api/dashboard';
import { ChartCard } from '../ui/ChartCard';

interface Props {
  history: ScorePoint[];
}

export function ScoreTrend({ history }: Props) {
  if (history.length < 2) {
    return (
      <ChartCard title="Score Trend" description="Run at least two store audits to see your score trend over time.">
        <div className="h-[120px]" />
      </ChartCard>
    );
  }

  const points = [...history].reverse().map((p) => ({ date: p.completed_at, score: p.score }));
  const latestScore = history[0].score;
  const firstScore = history[history.length - 1].score;
  const delta = latestScore - firstScore;
  const color = delta >= 0 ? '#15803D' : '#B91C1C';

  return (
    <ChartCard title="Score Trend" description={`Last ${history.length} completed audits`}>
      <div className="h-[160px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={points} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
            <XAxis dataKey="date" hide />
            <Tooltip
              contentStyle={{ borderRadius: 6, border: '1px solid #E2E8F0', fontSize: 14 }}
              labelFormatter={(v) => new Date(v).toLocaleDateString()}
            />
            <Line type="monotone" dataKey="score" stroke={color} strokeWidth={2} dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
      <span className={`text-[14px] font-semibold ${delta >= 0 ? 'text-success' : 'text-danger'}`}>
        {delta >= 0 ? '+' : ''}{delta} pts vs first recorded score
      </span>
    </ChartCard>
  );
}
